export interface Browser {
    currentUrl(): string
    readHash(): string
    clearHash(): void
    navigate(url: string): void
    openWindow(url: string, target: string): void
}

export const windowBrowser: Browser = {
    currentUrl: () => window.location.href,
    readHash: () => window.location.hash,
    clearHash: () => {
        window.location.hash = ''
    },
    navigate: (url) => {
        window.location.href = url
    },
    openWindow: (url, target) => {
        window.open(url, target)
    },
}
